<template>
  <div class="cp-mobility-offers">
    <div class="teq-container">
      <h2>nos offres Mobilize Share</h2>
      <div class="item">
        <div
          class="illust-container"
        >


          <picture >
            <source
                class="illust"
                media="(max-width: 499px)"
                srcset="../../../images/R-DAM_1385359_mobile.webp"
            >
            <source
                class="illust"
                media="(min-width: 500px)"
                srcset="../../../images/R-DAM_1385359.webp"
            >
            <img
                class="illust"
                src="../../../images/R-DAM_1385359.webp"
                alt=""
            >
    </picture>
        </div>
        <h3>locations en agence</h3>
        <div class="list-container">
          <h4>location à partir d'une journée et jusqu'à un mois</h4>
          <p>
            Vous êtes client particulier et vous souhaitez partir en vacances ou déménager ?<br>
            Vous êtes client professionnel et vous souhaitez louer un véhicule dans le cadre de votre activité professionnelle ?<br>
            Réservez un véhicule adapté à votre besoin parmi notre large gamme de véhicules Renault.
          </p>
        </div>
        <div class="list-container">
          <h4>nous vous proposons :</h4>
          <ul>
            <li>Un parcours de réservation en ligne ou en agence</li>
            <li>Des véhicules récents et entretenus dans notre réseau</li>
            <li>Une offre souple et adaptée à votre demande</li>
          </ul>
        </div>
        <arrow-link :href="'/location-en-agence'" />
      </div>
      <div class="item">
        <div
          class="illust-container"
        >
        <picture >
            <source
                class="illust"
                media="(max-width: 499px)"
                srcset="../../../images/R-DAM_1385365_mobile.webp"
            >
            <source
                class="illust"
                media="(min-width: 500px)"
                srcset="../../../images/R-DAM_1385365.webp"
            >
            <img
                class="illust"
                src="../../../images/R-DAM_1385365.webp"
                alt=""
            >
    </picture>
        </div>
        <h3>libre-service</h3>
        <div class="list-container">
          <h4> des voitures en autopartage</h4>
          <p>
            Besoin de vous déplacer pour une heure ou deux ? Optez pour la location à l'heure avec nos véhicules en libre service, disponibles 24h/24 et 7j/7 <br>
            Plus besoin de passer en agence : géolocalisez la voiture la plus proche de vous et partez à votre rendez-vous quand vous le souhaitez
          </p>
        </div>
        <div class="list-container">
          <h4>nous vous proposons :</h4>
          <ul>
            <li>100% mobile : réservez, payez et ouvrez votre véhicule grâce à l'application Mobilize Share</li>
            <li>Carburant, assurance et entretien inclus</li>
            <li>Ne payez qu’en fonction de votre utilisation</li>
          </ul>
        </div>
        <arrow-link :href="'/libre-service'" />
      </div>
    </div>
    <!--
    <div class="icon-container">
      <svg class="icon">
        <use
          xlink:href="#icon-mobilize"
        ></use>
      </svg>
    </div>
    -->
  </div>
</template>

<script>
import ArrowLink from '../shared/ArrowLink'

export default {
  name: 'MobilityOffers',

  props: {
    isMobility: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ArrowLink,
  },
}
</script>

<style lang="scss" scoped>
@import "../../../../_src/sass/config/vars";
@import "../../../../_src/sass/config/mixins";
@import "../../../../_src/sass/config/responsive";

.cp-mobility-offers {
  padding-top: 5rem;
  position: relative;
  //z-index: -1;

  @include teq-breakpoint($large) {
    margin-bottom: 5.5rem;
    padding-top: 17rem;
  }
}

.teq-container {
  @include teq-breakpoint($large) {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
}

h2 {
  font-size: 4.8rem;
  line-height: 100%;

  @include teq-breakpoint($large) {
    font-size: 7.2rem;
  }
}

h3 {
  margin: 2rem 0 2.8rem;

  @include teq-breakpoint($large) {
    margin: 3.3rem 0 2.5rem;
  }
}

h4 {
  color: #1f2532;
  font-size: 1.8rem;
  font-weight: bold;
  line-height: 3.24rem;
  margin: 1rem 0;
  //text-transform: uppercase;
}

.item {
  margin-bottom: 4rem;
  width: 100%;

  @include teq-breakpoint($large) {
    margin-bottom: 0;
    width: calc(50% - 1rem);
  }
}

.illust-container {
  margin-bottom: 2.6rem;
  overflow: hidden;
  position: relative;

  @include teq-breakpoint($large) {
    margin-bottom: 2rem;
  }

  &::before {
    content: "";
    display: block;
    padding-top: (9 / 16) * 100%;
    width: 100%;

    @include teq-breakpoint($large) {
      padding-top: (163 / 290) * 100%;
    }
  }
}

.illust {
  height: 100%;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 100%;
}

.list-container {
  margin-bottom: 1rem;

  @include teq-breakpoint($large) {
    margin-bottom: 2rem;
    padding-right: 8rem;
  }

  p {
    color: #1f2532;
    font-family: $f-graphie-book;
    font-size: 1.4rem;
    font-style: normal;
    font-weight: normal;
    line-height: 2.2rem;
    margin-bottom: 1.2rem;
    position: relative;
  }
}

ul {
  margin-bottom: 2.6rem;

  @include teq-breakpoint($large) {
    list-style: none;
    margin-bottom: 2.4rem;
  }
}

li {
  color: #1f2532;
  font-family: $f-graphie-book;
  font-size: 1.4rem;
  font-style: normal;
  font-weight: normal;
  line-height: 2.2rem;
  margin-bottom: 1.2rem;
  padding-left: 1.2rem;
  position: relative;

  &::before {
    border-bottom: 2px solid $orange;
    content: '';
    margin-left: -15px;
    position: absolute;
    top: 10px;
    width: 10px;
  }
}

.icon-container {
  display: none;
  margin-top: 60px;
  text-align: center;

  @include teq-breakpoint($large) {
    display: block;
  }

  .icon {
    height: 69px;
    width: 69px;
  }
}

</style>
